import axios from "axios";

export async function getPackagesByDistributor({ commit }, payload) {
  try {
    const { data } = await axios.get(`package/get-by-distributor`, {
      params: payload,
    });
    return data;
  } catch (e) {
    return e;
  }
}


export async function getPackagesByClient({ commit }, payload) {
  try {
    const { data } = await axios.get(`package/get-by-client`, {
      params: payload,
    });
    return data;
  } catch (e) {
    return e;
  }
}

export async function getPackagesInSample({ commit }, payload) {
  try {
    const { data } = await axios.post(`samples/sample-package`, payload);
    return data;
  } catch (e) {
    throw Error(e.message)
  }
}